<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="12">
            <h3>{{$route.name}}</h3>
            <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/reports/vehicle">Vehicle Report</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
            </b-breadcrumb>
            <div class="border-bottom"></div>
            </b-col>
        </b-row>
        <b-form class="mt-3 mx-2">
            <b-row>
                <b-col md="6">
                    <b-row>
                        <b-col class="mb-2">
                            <h4>Vehicle</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Plate</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{model.vehicle.plate !== null ? model.vehicle.plate : '-'}}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Merk</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.vehicle.merk !== null ? model.vehicle.merk : '-' }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Model</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.vehicle.model !== null ? model.vehicle.model : '-' }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Category</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{ model.vehicle.category.name !== null ? model.vehicle.category.name : '-' }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <template v-if="model.cancelTime !== '-' && model.canceledBy !== '-'">
                                <b-row>
                                    <b-col md="4">
                                    <label class="labels">Cancelled By</label>
                                    </b-col>
                                    <b-col md="8">
                                    <p>{{model.canceledBy !== null ? model.canceledBy : '-' }}</p>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4">
                                    <label class="labels">Cancel Time</label>
                                    </b-col>
                                    <b-col md="8">
                                    <p>{{model.cancelTime !== null ? model.cancelTime : '-' }}</p>
                                    </b-col>
                                </b-row>
                            </template>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="mt-5">
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Requested By</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{model.requestedBy !== null ? model.requestedBy : '-'}}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Request Time</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{model.requestTime !== null ? model.requestTime : '-' }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Start</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{model.startTime !== null ? model.startTime : '-' }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">End</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{model.endTime !== null ? model.endTime : '-' }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Created</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{model.createdAt !== null ? model.createdAt : '-' }}</p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <label class="labels">Note</label>
                        </b-col>
                        <b-col md="8">
                            <p>{{model.note !== null ? model.note : '-' }}</p>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <b-row>
                        <b-col class="mt-4">
                            <h4>Start Photo</h4>
                        </b-col>
                    </b-row>
                    <template v-if="startPhoto.length > 0">
                    <b-row v-for="strtPhoto in startPhoto" :key="strtPhoto.category">
                        <b-col md="12">
                            <h5>{{strtPhoto.category}}</h5>
                        </b-col>
                        <b-col md="12">
                            <viewer :images="strtPhoto.photo" :navbar="true" :movable="false">
                                <b-row class="mb-5" v-if="startPhoto.length > 0">
                                    <b-col md="3 mt-2" v-for="(src, index) in strtPhoto.photo" :key="index">
                                        <b-img center :src="src.path" class="img-responsive" width="200" height="150"/>
                                    </b-col>
                                </b-row>
                                <b-row v-else class="">
                                    <b-col md="12">
                                        <h5>Photo not submitted</h5>
                                    </b-col>
                                </b-row>
                            </viewer>
                        </b-col>
                    </b-row>
                    </template>
                    <template v-else>
                        <label class="label-photo">No Photo Submitted</label>
                    </template>
                </b-col>
                <b-col md="12">
                    <b-row>
                        <b-col class="mt-4">
                            <h4>Finish Photo</h4>
                        </b-col>
                    </b-row>
                    <template v-if="finishPhoto.length > 0">
                    <b-row v-for="fnshPhoto in finishPhoto" :key="fnshPhoto.category">
                        <b-col md="12">
                            <h5>{{fnshPhoto.category}}</h5>
                        </b-col>
                        <b-col md="12">
                            <viewer :images="fnshPhoto.photo" :navbar="true" :movable="false">
                                <b-row class="mb-5 " v-if="fnshPhoto.photo.length > 0">
                                    <b-col md="3 mt-3" v-for="(src, index) in fnshPhoto.photo" :key="index">
                                        <b-img center :src="src.path" class="img-responsive" width="200" height="150"/>
                                    </b-col>
                                </b-row>
                                <b-row v-else class="">
                                    <b-col md="12">
                                        <h5>Photo not submitted</h5>
                                    </b-col>
                                </b-row>
                            </viewer>
                        </b-col>
                    </b-row>
                    </template>
                    <template v-else>
                        <label class="label-photo">No Photo Submitted</label>
                    </template>
                </b-col>
            </b-row>
            <b-row class="mt-5 mb-5">
                <b-col md="12">
                    <h4>Status History</h4>
                    <table class="table table-hovered table-striped">
                        <thead>
                            <tr>
                                <th>Status</th>
                                <th>Created By</th>
                                <th>Created</th>
                            </tr>
                        </thead>
                        <tbody v-if="vehicleLogList.length > 0">
                            <tr>
                                <tr v-for="log in vehicleLogList" :key="log.uuid">
                                <td><b-badge :variant="getStatusColor(log.status)">{{log.status}}</b-badge></td>
                                <td>{{log.createdBy}}</td>
                                <td>{{getDateTime(log.createdAt)}}</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="text-center" colspan="3">There's no data</td>
                            </tr>
                        </tbody>
                    </table>
                </b-col>
            </b-row>
            <b-row class="mt-5 mb-5">
                <b-col md="12">
                    <h4>Report</h4>
                    <table class="table table-hovered table-striped">
                        <thead>
                            <tr>
                                <th>Amount</th>
                                <th>Type</th>
                                <th>Notes</th>
                                <th>Created</th>
                            </tr>
                        </thead>
                        <tbody v-if="vehicleReportList.length > 0">
                            <tr v-for="report in vehicleReportList" :key="report.uuid">
                                <td>{{ dataAccount.account.currency }} {{formatNumber(report.amount)}}</td>
                                <td>{{report.reportType.name}}</td>
                                <td>{{report.notes !== null && report.notes !== '' ? report.notes : '-'}}</td>
                                <td>{{getDateTime(report.createdAt)}}</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="text-center" colspan="4">There's no data</td>
                            </tr>
                        </tbody>
                    </table>
                </b-col>
            </b-row>
            <b-row class="mt-5 mb-5">
                <b-col md="12">
                    <h4>Report Photo</h4>
                </b-col>
                <b-col md="12">
                    <template v-if="reportPhoto.length > 0">
                        <b-row v-for="strtPhoto in reportPhoto" :key="strtPhoto.category">
                            <b-col md="12">
                                <h5>{{strtPhoto.category}}</h5>
                            </b-col>
                            <b-col md="12">
                                <viewer :images="strtPhoto.photo" :navbar="true" :movable="false">
                                    <b-row class="mb-5 " v-if="reportPhoto.length > 0">
                                    <b-col md="3 mt-3" v-for="(src, index) in strtPhoto.photo" :key="index">
                                        <b-img center :src="src.path" class="img-responsive" width="200" height="150"/>
                                    </b-col>
                                    </b-row>
                                    <b-row v-else class="">
                                    <b-col md="12">
                                        <h5>Photo not submited</h5>
                                    </b-col>
                                    </b-row>
                                </viewer>
                            </b-col>
                        </b-row>
                    </template>
                    <template v-else>
                        <label class="label-photo">No Photo Submitted</label>
                    </template>
                </b-col>
            </b-row>
        </b-form>
        <b-button class="mt-3" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
    </b-card>
</template>

<script>
    import 'viewerjs/dist/viewer.css'
    import Viewer from 'v-viewer'
    import Vue from 'vue'
    Vue.use(Viewer)

    export default {
        name: 'vehicle-report-details',
        data () {
            return {
                isLoading: false,
                dataAccount: this.$store.getters['account/accountData'],
                dataKey: {
                    vehicleReport: 'vehicleRequestStatusLog',
                    vehicleRequestLog: 'vehicleRequestStatusLog'
                },
                apiUrl: {
                    vehicleRequest: window.AppConfig.apiUrl + 'vehicle-request',
                    vehicleReport: window.AppConfig.apiUrl + 'vehicle-report?request=' + this.$route.params.uuid + '&limit=10000',
                    requestLog: window.AppConfig.apiUrl + 'request-status-log?vehicle_request_uuid=' + this.$route.params.uuid + '&limit=10000',
                    vehiclePhoto: window.AppConfig.apiUrl + 'vehicle-request-photo?vehicle_request_uuid=' + this.$route.params.uuid
                },
                type: null,
                formData: {
                    note: null
                },
                startPhoto: [],
                finishPhoto: [],
                reportPhoto: [],
                vehicleLogList: [],
                vehicleReportList: [],
                model: {
                    requestNote: '',
                    requestTime: '',
                    approveTime: '',
                    cancelTime: '',
                    rejectTime: '',
                    startTime: '',
                    endTime: '',
                    note: '',
                    createdAt: '',
                    updatedAt: '',
                    isActive: 1,
                    vehicle: {
                        uuid: null,
                        category: {
                            uuid: null,
                            name: null
                        }
                    },
                    startPhoto: null,
                    finishPhoto: null,
                    approvedBy: null,
                    rejectedBy: null
                }
            }
        },
        watch: {
            '$route.params.uuid': function (val) {
                this.getDetail()
            }
        },
        mounted () {
            this.getDetail()
            this.getStartPhoto()
            this.getFinishPhoto()
            this.getVehicleLog()
            this.getVehicleReport()
        },
        methods: {
            getDetail () {
                this.isLoading = true
                this.$http.get(this.apiUrl.vehicleRequest + '/' + this.$route.params.uuid)
                .then(response => {
                this.model.requestTime = this.$moment(response.data.requestTime).format('YYYY-MM-DD hh:mm A')
                this.model.approveTime = response.data.approveTime !== null ? this.$moment(response.data.approveTime).format('YYYY-MM-DD hh:mm A') : '-'
                this.model.cancelTime = response.data.cancelTime !== null ? this.$moment(response.data.cancelTime).format('YYYY-MM-DD hh:mm A') : '-'
                this.model.rejectTime = response.data.rejectTime !== null ? this.$moment(response.data.rejectTime).format('YYYY-MM-DD hh:mm A') : '-'
                this.model.startTime = response.data.startTime !== null ? this.$moment(response.data.startTime).format('YYYY-MM-DD hh:mm A') : '-'
                this.model.endTime = response.data.endTime !== null ? this.$moment(response.data.endTime).format('YYYY-MM-DD hh:mm A') : '-'
                this.model.note = response.data.note !== null ? response.data.note : '-'
                this.model.createdAt = response.data.createdAt !== null ? this.$moment(response.data.createdAt).format('YYYY-MM-DD hh:mm A') : '-'
                this.model.updatedAt = response.data.updatedAt
                this.model.uuid = response.data.uuid
                this.model.vehicle = response.data.vehicle
                this.model.status = response.data.status
                this.model.startPhoto = response.data.startPhoto
                this.model.finishPhoto = response.data.finishPhoto
                this.model.approvedBy = response.data.approvedBy !== null ? response.data.approvedBy : '-'
                this.model.rejectedBy = response.data.rejectedBy !== null ? response.data.rejectedBy : '-'
                this.model.canceledBy = response.data.canceledBy !== null ? response.data.canceledBy : '-'
                this.model.rejectedBy = response.data.rejectedBy !== null ? response.data.rejectedBy : '-'
                this.model.requestedBy = response.data.requestedBy !== null ? response.data.requestedBy : '-'
                this.isLoading = false
                })
                .catch(error => {
                this.isLoading = false
                this.$store.dispatch('notification/error', error)
                // this.$router.push('/notfound')
                })
            },
            getStartPhoto () {
                let temp = []
                this.$http.get(this.apiUrl.vehiclePhoto + '&status=started').then(resp => {
                    resp.data._embedded.requestPhoto.forEach((data, index) => {
                        if (data.requestPhotoCategory !== null && typeof data.requestPhotoCategory === 'object') {
                        temp.push(data.requestPhotoCategory.name)
                        }
                    })
                    temp = [...new Set(temp)]
                    temp.forEach((dataTemp, index) => {
                        this.startPhoto.push({
                            category: dataTemp,
                            photo: []
                        })
                        resp.data._embedded.requestPhoto.forEach(data => {
                            if (data.requestPhotoCategory !== null && typeof data.requestPhotoCategory === 'object' && dataTemp === data.requestPhotoCategory.name) {
                                this.startPhoto[index].photo.push({
                                    status: data.status,
                                    path: data.path,
                                    uuid: data.uuid
                                })
                            }
                        })
                    })
                })
            },
            getFinishPhoto () {
                let temp = []
                this.$http.get(this.apiUrl.vehiclePhoto + '&status=finished').then(resp => {
                    resp.data._embedded.requestPhoto.forEach((data, index) => {
                        if (data.requestPhotoCategory !== null && typeof data.requestPhotoCategory === 'object') {
                        temp.push(data.requestPhotoCategory.name)
                        }
                    })
                    temp = [...new Set(temp)]
                    temp.forEach((dataTemp, index) => {
                        this.finishPhoto.push({
                            category: dataTemp,
                            photo: []
                        })
                        resp.data._embedded.requestPhoto.forEach(data => {
                            if (data.requestPhotoCategory !== null && typeof data.requestPhotoCategory === 'object' && dataTemp === data.requestPhotoCategory.name) {
                                this.finishPhoto[index].photo.push({
                                    status: data.status,
                                    path: data.path,
                                    uuid: data.uuid
                                })
                            }
                        })
                    })
                })
            },
            getVehicleLog () {
                this.$http.get(this.apiUrl.requestLog).then(resp => {
                this.vehicleLogList = []
                    resp.data._embedded.vehicleRequestStatusLog.forEach(data => {
                        this.vehicleLogList.push(data)
                    })
                })
            },
            getVehicleReport () {
                this.$http.get(this.apiUrl.vehicleReport).then(resp => {
                this.vehicleReportList = []
                    resp.data._embedded.vehicleReport.forEach(data => {
                        this.vehicleReportList.push(data)
                        if (data.reportType !== null) {
                            this.reportPhoto.push({
                                category: data.reportType.name,
                                photo: data.reports
                            })
                        }
                    })
                })
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm A')
                } else {
                    return '-'
                }
            },
            goBack () {
                window.goBack(this)
            },
            formatNumber (val) {
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            },
            getStatusColor (val) {
                switch (val) {
                case 'Approved':
                    return 'primary'
                    // eslint-disable-next-line no-unreachable
                    break
                case 'Requested':
                    return 'info'
                    // eslint-disable-next-line no-unreachable
                    break
                case 'Canceled':
                    return 'secondary'
                    // eslint-disable-next-line no-unreachable
                    break
                case 'Finished':
                    return 'success'
                    // eslint-disable-next-line no-unreachable
                    break
                case 'Started':
                    return 'primary'
                    // eslint-disable-next-line no-unreachable
                    break
                }
            }
        }
    }
</script>